import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/eye-off.vue
var s = {
	name: "DtIconEyeOff",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--eye-off"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Eye Off",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [i("g", {
		"clip-path": `url(#${e.uniqueID}a)`,
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		fill: "currentColor"
	}, [...t[0] || (t[0] = [i("path", { d: "M6 2c1.934 0 3.308.972 4.18 1.91a7.698 7.698 0 0 1 1.196 1.716 4.436 4.436 0 0 1 .077.16l.004.012.002.003v.001L11 6l.46-.197a.5.5 0 0 1-.007.409c-.24.515-.542.999-.898 1.442a.5.5 0 1 1-.78-.627c.258-.32.481-.664.669-1.028a6.694 6.694 0 0 0-.998-1.409C8.693 3.78 7.566 3 6.001 3c-.192 0-.384.013-.574.036a.5.5 0 1 1-.124-.992A5.81 5.81 0 0 1 6 2Zm0 8c-1.934 0-3.307-.97-4.18-1.91A7.694 7.694 0 0 1 .624 6.374a4.515 4.515 0 0 1-.076-.16l-.005-.011-.001-.004-.001-.001s-.068-.295.007-.412c.075-.117 1.15-1.853 1.995-2.536L.647 1.354a.5.5 0 0 1 .707-.707l10 10a.5.5 0 1 1-.707.707L8.619 9.326c-.8.443-1.7.676-2.62.674Zm-.964-3.588a1 1 0 0 1-.022-.69L6.28 6.985a1 1 0 0 1-1.243-.574Zm.962 1.625a2 2 0 0 0 1.027-.305l.851.851A4.37 4.37 0 0 1 6.002 9H6c-1.566 0-2.692-.778-3.446-1.59a6.694 6.694 0 0 1-.997-1.408 6.263 6.263 0 0 1 1.697-2.04l1.014 1.013a2 2 0 0 0 1.73 3.062Z" }, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=eye-off.js.map